import AddIcon from "@mui/icons-material/Add";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import { EDialogAction } from "../Components/Enum/DialogActionEnum";
import { Button, Card, Select } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import Scaffold from "../Components/Layout/Scaffold";
import PassportTable from "../Components/Passport/PassportTable";
import { ProcessCardPassportEnumDisplayLabel } from "../Types/Enum";

const Passports = () => {
  let [hide, setHide] = useState(true);

  let [filter, setfilter] = useState<any>({});
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [textInput, setTextInput] = useState("");

  const handleTextInputChange = (event: any) => {
    setTextInput(event.target.value);
  };

  function hideDiv() {
    if (hide == true) {
      setHide(false);
    } else {
      setHide(true);
    }
  }

  function changeFilters(key: string, value: string) {
    setfilter((oldState: any) => {
      return { ...oldState, [key]: value };
    });
  }

  function clearData() {
    setfilter({});
  }
  function clearSearch() {
    setTextInput("");
    changeFilters("keyword", "");
  }

  function editDialogClose() {
    setEditDialogVisibility(false);
    changeFilters("timestamp", "" + Date.now());
  }

  return (
    <Scaffold
      title="Passport List"
      actions={[
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": {
              maxWidth: "75ch",
            },
          }}
          noValidate
          autoComplete="off"
        >
          <div>
            <TextField
              id="outlined-search"
              type="search"
              label="Search"
              variant="outlined"
              size="small"
              placeholder="Enter search keyword"
              value={textInput}
              onChange={handleTextInputChange}
            />
          </div>
        </Box>,
        <Button
          endIcon={<SearchOutlined />}
          className="mx-1"
          variant="contained"
          color="secondary"
          onClick={() => {
            changeFilters("keyword", "" + textInput);
          }}
        >
          Search
        </Button>,
        <Button
          variant={hide ? "outlined" : "contained"}
          color="secondary"
          onClick={hideDiv}
          startIcon={<FilterAltIcon fontSize="small" />}
        >
          {hide ? "Show" : "Hide"} Filters
        </Button>,
      ]}
      secondaryAction={
        <>
          {!hide && (
            <Card
              className="flex w-full space-x-4 px-2 py-3 border"
              elevation={0}
            >
              

              <div className="flex ml-8 ">
                <div>
                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="status-select-standard-label">
                      Status
                    </InputLabel>
                    <Select
                      size="small"
                      labelId="status-select-standard-label"
                      label="Status"
                      id="status-select-standard"
                      value={filter.status || ""}
                      onChange={(event) => {
                        changeFilters("status", event.target.value);
                        // if (event.target.value == "") {
                        //   clearData();
                        // }
                      }}
                    >
                      {Object.keys(ProcessCardPassportEnumDisplayLabel).map((key) => (
                        <MenuItem key={key} value={key}>
                          {ProcessCardPassportEnumDisplayLabel[key]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                endIcon={<SearchOutlined />}
                onClick={() => {
                  changeFilters("timestamp", "" + Date.now());
                }}
              >
                Search
              </Button>
              <Button
                className="mt-1"
                color="error"
                variant="text"
                onClick={clearData}
              >
                <CancelIcon />
              </Button>
            </Card>
          )}
        </>
      }
    >
      <div>
        <PassportTable filter={filter} />
      </div>
    </Scaffold>
  );

};

export default Passports;
